import { Navigate } from 'react-router-dom'
import { useChosenCompany } from '../../../context/UserProvider'
import SignalSpinnerLoader from '../../../components/loaders/SignalSpinnerLoader'

const MyCar = () => {
  const company = useChosenCompany()

  if (!company) {
    return <SignalSpinnerLoader />
  }

  if (!company.accountNo) {
    return (
      <div className="w-full h-screen flex-col gap-2 flex items-center justify-center">
        <p>Vi fant ingen bil registrert på deg.</p>
      </div>
    )
  }

  return <Navigate to={`/cars/${company.accountNo}?type=account`} replace />
}

export default MyCar
